export const ChangeNavDrawerItem = "ChangeNavDrawerItem"
export const SwapItemInMainLayout = "SwapItemInMainLayout"